import React from 'react'
import Train from 'SVGPath/train.svg'
import Hotel from 'SVGPath/hotel.svg'
import Flight from 'SVGPath/flight.svg'
import './index.scss'
import { Helmet } from 'react-helmet'

const SupportHead = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Cleartrip Customer Support & Contact Number | Connect with us
          on +91 9595333333
        </title>
        <meta name="title" content="Cleartrip Customer Support & Contact Number | Connect with us on +91 9595333333" />
        <meta
          name="description"
          content="Get in touch with Cleartrip customer care on +91 9595333333 for your queries.
        Or visit the page to get more information on your bookings."
        />
      </Helmet>
      <section className="bg-white" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
        <div className="flex flex-column" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
          <div className="flex flex-middle flex-center" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
            <h1 className="fs-17 welcomeHead" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>Welcome to Cleartrip Support</h1>
          </div>
          <div className="flex-middle flex-center" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
            <p className="fs-13 welcomeSubHead" style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}>
              Find answers to all your queries, call us at +91 9595333333
            </p>
          </div>
          <div className="flex flex-middle flex-center pb-8">
            <div className="px-3">
              <Flight fill="#CCCCCC" />
            </div>
            <div className="px-3">
              <Hotel fill="#CCCCCC" />
            </div>
            <div className="px-3">
              <Train fill="#CCCCCC" />
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}
export default SupportHead
